import { IInspectionResult } from 'APIPackage/CatalogsModule/interfaces/IInspectionResult';
import { InspectionResultActionTypeEnum } from 'APIPackage/CatalogsModule/enums/InspectionResultActionTypeEnum';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ErknmInspectionResultMessage.module.scss';

interface IErknmInspectionResultMessageProps {
  inspectionResult?: IInspectionResult;
}

export const ErknmInspectionResultMessage = ({ inspectionResult }: IErknmInspectionResultMessageProps) => {
  if (!inspectionResult) {
    return null;
  }

  switch (inspectionResult.resultActionType) {
    case InspectionResultActionTypeEnum.BLOCK_KNM:
    case InspectionResultActionTypeEnum.LIGHT_RED:
      return (
        <div className={styles.LightRed}>
          <Hint variant="alert" text={inspectionResult.inspectionMessage} />
        </div>
      );
    case InspectionResultActionTypeEnum.LIGHT_YELLOW:
      return (
        <div className={styles.LightYellow}>
          <Hint text={inspectionResult.inspectionMessage} />
        </div>
      );
    default:
      return null;
  }
};
